import { namespace } from 'vuex-class';
import type { ITwilioState } from '@signing-page/integrations/twilio/store/twilio.types';

export const Twilio = namespace('integrations/twilio');

export enum ETwilioAction {
  CallPhone = 'callPhone',
  CallPhoneSuccess = 'callPhoneSuccess',
  CallPhoneFailed = 'callPhoneFailed',
  CancelCall = 'cancelCall',
}

export enum ETwilioMutation {
  SetError = 'setError',
  SetLoading = 'setLoading',
  SetCallSid = 'setCallSid',
}

export const state: ITwilioState = {
  callSid: '',
  loading: false,
  error: null,
};
